class Modal {
  constructor(modalContainer) {
    this.modalToggles = Array.from(document.querySelectorAll('[data-modal-target="' + modalContainer.id + '"]'));
    this.modalContainer = modalContainer;
    this.modalOpen = false;
  }

  init() {
    if (this.modalContainer) {
      this.modalToggles.forEach((el) => {
        el.addEventListener('click', (e) => {
          e.preventDefault();
          e.stopImmediatePropagation();

          this.openModal();
        });
      });
    } else {
      console.warn('The modal targetted by the data attribute (' + this.modalToggle.getAttribute('data-modal-target') + ') does not exist. Ensure the data attribute is correct.');
    }
  }

  openModal() {
    if (!this.modalOpen) {
      this.modalContainer.classList.add('js-modal-open');
      document.body.classList.add('js-modal-open');
      this.modalOpen = true;

      let modalDismissButtons = Array.from(this.modalContainer.querySelectorAll('[data-modal-dismiss]'));
      if (modalDismissButtons) {
        modalDismissButtons.forEach(modalDismissButton => {
          modalDismissButton.addEventListener('click', e => {
            e.preventDefault();
            this.dismissModal();
          });
        });
      }

      document.addEventListener('click', this.handleDismissClick.bind(this));
    }
  }

  handleDismissClick(e) {
    if (e.target == this.modalContainer) {
      this.dismissModal();
    }
  }

  dismissModal() {
    document.removeEventListener('click', this.handleDismissClick.bind(this));
    this.modalContainer.classList.remove('js-modal-open');
    document.body.classList.remove('js-modal-open');
    this.modalOpen = false;
  }
}

export default Modal;



// WEBPACK FOOTER //
// ./assets/js/modules/modal.js